<template>
    <div>
        <br/>
        <v-container fluid grid-list-sm>
        <v-layout row wrap>
         <v-flex xs5 offset-xs3>
             <v-card align-center>
                 <v-container>
                   <slot />
                 </v-container>
             </v-card>
         </v-flex>
        </v-layout>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'HomeTemplate'
}
</script>


// WEBPACK FOOTER //
// src/components/pages/templates/HomeTemplate.vue